import '../styles/fonts.scss';
import '../styles/theme.scss';

import asyncSVG from '@global/asyncSVG';
import { loadIcons } from '@global/SVGSprite';
import convertDataAttributesToObject from '@global/convertDataAttributesToObejct';

import { moduleDefinition } from './modules';

/**
 * Async Modules: Modules are defined in ./modules/definitions.ts
 */
const bootstrap = {
  init() {
    asyncSVG.load('./wp-content/themes/taylor-foods/dist/sprite.svg');
    this.asyncModules(moduleDefinition);
  },
  // Has to be duplicated because of build issue I couldn't figure out.
  asyncModules: function (modules: ModuleDefinition[]) {
    (modules ?? []).forEach(({ selector, moduleName, defaultArgs }) => {
      (document.querySelectorAll<HTMLElement>(selector) ?? []).forEach((el) => {
        const formattedArgs = convertDataAttributesToObject(el.dataset ?? {});
        const args = { ...defaultArgs, ...formattedArgs };

        return import(`./modules/${moduleName}.ts`).then((mod) => {
          const Module = mod.default;
          return new Module(el, args);
        });
      });
    });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  bootstrap.init();
});

// SVG Sprite Loader
loadIcons(require.context('@taylor-foods/resources/assets/icons', true, /\.svg$/));
